import { css } from '@emotion/react';

export const stylesInit = () => css`
  display: flex;
  justify-content: space-between;
  padding: 16px 32px;
`;
